var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex flex-column gap-20" }, [
    _c("strong", { staticClass: "font-size-125" }, [
      _vm._v(_vm._s(_vm._f("trans")("CONTACT US"))),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex flex-column gap-10" },
      [
        _c("TextInput", {
          staticClass: "press-text-input",
          attrs: {
            type: "text",
            name: "full_name",
            placeholder: _vm._f("trans")("Full Name"),
            disabled: false,
            autocomplete: "off",
            borderClass: "border-5",
          },
          model: {
            value: _vm.fullName,
            callback: function ($$v) {
              _vm.fullName = $$v
            },
            expression: "fullName",
          },
        }),
        _vm._v(" "),
        _c("TextInput", {
          staticClass: "press-text-input",
          attrs: {
            type: "text",
            name: "emial",
            placeholder: _vm._f("trans")("E-Mail"),
            disabled: false,
            autocomplete: "off",
            borderClass: "border-5",
          },
          model: {
            value: _vm.email,
            callback: function ($$v) {
              _vm.email = $$v
            },
            expression: "email",
          },
        }),
        _vm._v(" "),
        _c("TextInput", {
          staticClass: "press-text-input",
          attrs: {
            type: "text",
            name: "url_channel",
            placeholder: _vm._f("trans")("URL/Channel"),
            disabled: false,
            autocomplete: "off",
            borderClass: "border-5",
          },
          model: {
            value: _vm.urlOrChannel,
            callback: function ($$v) {
              _vm.urlOrChannel = $$v
            },
            expression: "urlOrChannel",
          },
        }),
        _vm._v(" "),
        _c("TextArea", {
          staticClass: "press-text-area",
          attrs: {
            name: "message",
            skipFocus: true,
            hideLength: true,
            rows: "4",
            placeholder: _vm._f("trans")("additional notes"),
            type: "text",
          },
          model: {
            value: _vm.message,
            callback: function ($$v) {
              _vm.message = $$v
            },
            expression: "message",
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-lg submit-btn send-btn",
            attrs: { type: "button" },
            on: { click: _vm.submitContactUs },
          },
          [
            _c("strong", { staticClass: "text-uppercase" }, [
              _vm._v(_vm._s(_vm._f("trans")("Send", {}, "general"))),
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "fa fa-arrow-right lh-inherit" }),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }